import React from 'react'
import '../style/Contact.css'
const Contact = () => {
  return (
    <div>
       <section className="contact-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Contact Us</h1>
            </div>
          </div>
        </div>
      </section>
      <section className="py-5" style={{ backgroundColor: '#f0f0f0' }}>
  <div className="container">
    <div className="row justify-content-center text-center mb-2 mb-lg-4">
      <div className="col-lg-8 col-xxl-7">
        <span className="text-muted" style={{ color: '#0D6EFD' }}>Let's Talk</span>
        <h2 className="display-5 fw-bold mb-3" style={{ color: '#0D6EFD' }}>Contact Us</h2>
        <p className="lead mb-0" style={{ color: '#6c757d' }}>
          Welcome to Vana Tour and Car Rental! We offer unforgettable experiences with our fleet of high-quality vehicles and guided tours. Whether you're looking to explore the beauty of Ethiopia or need a reliable car rental, we're here to help!
        </p>
      </div>
    </div>
    <div className="row justify-content-center">
      <div className="col-md-10 col-lg-6">
        <form>
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="mb-3">
                <input className="form-control bg-light" placeholder="First name" type="text" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <input className="form-control bg-light" placeholder="Last name" type="text" />
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-3">
                <textarea className="form-control bg-light" placeholder="Your message" rows="4"></textarea>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-grid">
                <button className="btn" style={{ backgroundColor: '#0D6EFD', color: '#fff' }} type="submit">Send message</button>
              </div>
            </div>
          </div>
        </form>
      </div>
      
      <div className="col-md-4">
        <h4 className="fw-bold mb-3" style={{ color: '#0D6EFD' }}>Get in Touch</h4>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <th scope="row" style={{ backgroundColor: '#0D6EFD', color: '#fff' }}>Address</th>
              <td>Bole Medhanialem, Addis Ababa, Ethiopia</td>
            </tr>
            <tr>
              <th scope="row" style={{ backgroundColor: '#0D6EFD', color: '#fff' }}>Phone</th>
              <td>+251 92 123 4567</td>
            </tr>
            <tr>
              <th scope="row" style={{ backgroundColor: '#0D6EFD', color: '#fff' }}>Email</th>
              <td><a href="mailto:info@vanatour.com" style={{ color: '#0D6EFD' }}>info@vanatour.com</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div className="mt-5">
    <iframe 
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d23787.10323946393!2d38.74617437952562!3d9.013495612579533!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b8b482727bbcf%3A0xaebea8f380a674ea!2sBole%20Medhanialem%2C%20Addis%20Ababa%2C%20Ethiopia!5e0!3m2!1sen!2sus!4v1693341636345!5m2!1sen!2sus" 
      width="100%" height="450" style={{ border: '0', borderRadius: '8px' }} 
      allowFullScreen="" loading="lazy"
    ></iframe>
  </div>
</section>
<section class="py-5">
	<div class="container">
		<div class="row justify-content-center text-center mb-3">
			<div class="col-lg-8 col-xl-7">
				<span class="text-muted">F.A.Q</span>
				<h2 class="display-5 fw-bold text-primary">Frequently Asked Questions</h2>
				<p class="lead text-muted">Get answers to all your questions about van tours, car rentals, and bookings.</p>
			</div>
		</div>
		<div class="row justify-content-center">
			<div class="col-md-5">
				<span class="text-muted">Need Assistance?</span>
				<h2 class="pb-4 fw-bold text-primary">Have Any Questions?</h2>
				<p class="text-muted">Explore our FAQs to learn more about booking a van tour, car rental policies, cancellation rules, and more.</p>
				<a class="btn btn-primary btn-lg mt-3" href="#">Contact us</a>
			</div>
			<div class="col-md-7">
				<div class="accordion" id="Questions-accordion">
		
					<div class="accordion-item">
						<h2 class="accordion-header" id="Questions-headingOne">
							<button aria-controls="Questions-collapseOne" aria-expanded="false" class="accordion-button collapsed bg-light text-dark" data-bs-target="#Questions-collapseOne" data-bs-toggle="collapse" type="button">
								<div class="text-muted me-3">
									<svg class="bi bi-question-circle-fill" fill="currentColor" height="24" viewbox="0 0 16 16" width="24" xmlns="http://www.w3.org/2000/svg">
										<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"></path>
									</svg>
								</div>
								How do I book a van tour or car rental?
							</button>
						</h2>
						<div aria-labelledby="Questions-headingOne" class="accordion-collapse collapse" data-bs-parent="#Questions-accordion" id="Questions-collapseOne">
							<div class="accordion-body">
								To book a van tour or car rental, simply visit our booking page, choose your preferred vehicle or tour package, select the dates, and complete your payment. It's easy and quick!
							</div>
						</div>
					</div>

				
					<div class="accordion-item">
						<h2 class="accordion-header" id="Questions-headingTwo">
							<button aria-controls="Questions-collapseTwo" aria-expanded="false" class="accordion-button collapsed bg-light text-dark" data-bs-target="#Questions-collapseTwo" data-bs-toggle="collapse" type="button">
								<div class="text-muted me-3">
									<svg class="bi bi-question-circle-fill" fill="currentColor" height="24" viewbox="0 0 16 16" width="24" xmlns="http://www.w3.org/2000/svg">
										<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"></path>
									</svg>
								</div>
								Can I cancel my van tour or car rental reservation?
							</button>
						</h2>
						<div aria-labelledby="Questions-headingTwo" class="accordion-collapse collapse" data-bs-parent="#Questions-accordion" id="Questions-collapseTwo">
							<div class="accordion-body">
								Yes, you can cancel your reservation up to 48 hours before your tour or rental date for a full refund. Cancellations within 48 hours may incur a small fee depending on the service.
							</div>
						</div>
					</div>

		
					<div class="accordion-item">
						<h2 class="accordion-header" id="Questions-headingThree">
							<button aria-controls="Questions-collapseThree" aria-expanded="false" class="accordion-button collapsed bg-light text-dark" data-bs-target="#Questions-collapseThree" data-bs-toggle="collapse" type="button">
								<div class="text-muted me-3">
									<svg class="bi bi-question-circle-fill" fill="currentColor" height="24" viewbox="0 0 16 16" width="24" xmlns="http://www.w3.org/2000/svg">
										<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"></path>
									</svg>
								</div>
								Do you provide insurance with the car rental?
							</button>
						</h2>
						<div aria-labelledby="Questions-headingThree" class="accordion-collapse collapse" data-bs-parent="#Questions-accordion" id="Questions-collapseThree">
								<div class="accordion-body">
								Yes, we provide comprehensive insurance with all our rentals. You can choose from various plans to suit your needs. Please ask about insurance when booking.
							</div>
						</div>
					</div>

				
					<div class="accordion-item">
						<h2 class="accordion-header" id="Questions-headingFour">
							<button aria-controls="Questions-collapseFour" aria-expanded="false" class="accordion-button collapsed bg-light text-dark" data-bs-target="#Questions-collapseFour" data-bs-toggle="collapse" type="button">
								<div class="text-muted me-3">
									<svg class="bi bi-question-circle-fill" fill="currentColor" height="24" viewbox="0 0 16 16" width="24" xmlns="http://www.w3.org/2000/svg">
										<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"></path>
									</svg>
								</div>
								What happens if I damage the rental car?
							</button>
						</h2>
						<div aria-labelledby="Questions-headingFour" class="accordion-collapse collapse" data-bs-parent="#Questions-accordion" id="Questions-collapseFour">
							<div class="accordion-body">
								If the car is damaged during your rental period, you will be liable for the cost of repairs. However, our insurance covers a significant portion of the repair cost depending on your chosen plan.
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

      
    </div>
  )
}

export default Contact
